import React from "react";

import { csrfToken } from "utils/csrf";

const DEFAULT_QUERY = `# Welcome to the pganalyze API!
#
# Learn more: https://pganalyze.com/docs/api
#
# Press ▶ to run this query:
query {
  getCurrentUserDetails {
    id
    fullname
  }
}`;

function ApiExplorer({ graphqlUri }: { graphqlUri: string }) {
  const fetcher = async (graphQLParams: any) => {
    const response = await fetch(graphqlUri, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphQLParams),
    });

    const result = await response.json();
    delete result["extensions"];
    return result;
  };

  const GraphiQL = window.GraphiQL;
  return (
    <GraphiQL fetcher={fetcher} query={DEFAULT_QUERY}>
      <GraphiQL.Logo>pganalyze API Explorer</GraphiQL.Logo>
    </GraphiQL>
  );
}

export default ApiExplorer;
